import React from 'react';

import ToggleIcon from '../../icons/ToggleIcon';

function NotificationItem({ label, name, checked, includeMonths = false, monthsValue, onChange }) {
  return (
    <label
      className={`account__notification-item${checked ? '' : ' account__notification-item--disabled'}`}
      htmlFor={`${name}-toggle`}
    >
      <div className=" account__notification-column">
        {label}
      </div>
      {includeMonths
        ? (
          <div className="account__toggle account__notification-column">
            <div className="account__toggle-focus">
              <input
                name={name}
                type="checkbox"
                checked={checked || false}
                onChange={onChange}
                id={`${name}-toggle`}
              />
              <ToggleIcon checked={checked} />
            </div>
            <div>
              every
              <input
                type="number"
                name={`${name}Interval`}
                value={monthsValue || 12}
                onChange={onChange}
              />
              months
            </div>
          </div>
        ) : (
          <div className="account__toggle account__toggle-focus account__notification-column">
            <input
              name={name}
              type="checkbox"
              checked={checked}
              onChange={onChange}
              id={`${name}-toggle`}
            />
            <ToggleIcon checked={checked} />
          </div>
        )
      }
    </label>
  );
}
export default NotificationItem;



// WEBPACK FOOTER //
// ./src/components/features/account/NotificationItem.js